import { z } from "zod";

export const bankingDepositFiscalDocumentSchema = z.object({
  number: z.string({ message: 'Campo obrigatório' }).trim().min(1, { message: 'Campo obrigatório' }),
  serial: z.string({ message: 'Campo obrigatório' }).trim().min(1, { message: 'Campo obrigatório' }),
  pdf: z.custom().optional().nullable(),
  xml: z.custom().optional().nullable(),
});

export type BankingDepositFiscalDocumentValidationSchema = z.infer<typeof bankingDepositFiscalDocumentSchema>;
